var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _templateObject = _taggedTemplateLiteral(['\n  margin-top: ', '\n'], ['\n  margin-top: ', '\n']),
  _templateObject2 = _taggedTemplateLiteral(['\n  columns: auto ', ';\n  column-fill: balance;\n\n  .btn {\n    display: block;\n    column-span: all;\n  }\n'], ['\n  columns: auto ', ';\n  column-fill: balance;\n\n  .btn {\n    display: block;\n    column-span: all;\n  }\n']);
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

/* eslint-disable no-nested-ternary */

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button, FormGroup, Label } from 'reactstrap';
import { RadioGroup, Radio } from 'react-radio-group';
import styled from 'styled-components';
var ResetButton = styled(Button)(_templateObject, function (p) {
  return p.inline && '-5px';
});
var SRadioGroup = styled(RadioGroup)(_templateObject2, function (p) {
  return p.columns;
});
var CordataRadioGroup = function CordataRadioGroup(_ref) {
  var id = _ref.id,
    value = _ref.value,
    error = _ref.error,
    touched = _ref.touched,
    disabled = _ref.disabled,
    options = _ref.options,
    inline = _ref.inline,
    className = _ref.className,
    onChange = _ref.onChange,
    clearable = _ref.clearable,
    getOptionLabel = _ref.getOptionLabel,
    getOptionValue = _ref.getOptionValue,
    components = _ref.components,
    columns = _ref.columns,
    props = _objectWithoutProperties(_ref, ['id', 'value', 'error', 'touched', 'disabled', 'options', 'inline', 'className', 'onChange', 'clearable', 'getOptionLabel', 'getOptionValue', 'components', 'columns']);
  var canColumnize = columns && !inline;
  var RG = canColumnize ? SRadioGroup : RadioGroup;
  var classesRadioAndCheckbox = classnames(className, 'h-100', {
    'is-invalid text-danger': error && touched
  });
  var handleReset = function handleReset() {
    return onChange(undefined);
  };
  return React.createElement(RG, {
    selectedValue: value,
    name: id,
    onChange: onChange,
    className: classesRadioAndCheckbox,
    disabled: disabled,
    columns: columns
  }, options.map(function (o) {
    return React.createElement(FormGroup, {
      check: true,
      inline: inline,
      key: getOptionValue ? id + '-' + getOptionValue(o) : o.value
    }, React.createElement(Radio, {
      className: 'form-check-input',
      id: getOptionValue ? id + '-' + getOptionValue(o) : id + '-' + o.value,
      value: getOptionValue ? getOptionValue(o) : o.value,
      disabled: o.disabled || disabled
    }), React.createElement(Label, {
      'for': id + '-' + (getOptionValue ? getOptionValue(o) : o.value),
      check: true
    }, components && components.Option ? React.createElement(components.Option, _extends({
      option: o
    }, props)) : getOptionLabel ? getOptionLabel(o) : o.label));
  }), !disabled && clearable && React.createElement(ResetButton, {
    inline: inline,
    color: 'link',
    size: 'sm',
    className: 'pl-0',
    onClick: handleReset,
    disabled: disabled
  }, 'Reset'));
};
CordataRadioGroup.propTypes = {
  id: PropTypes.string.isRequired,
  error: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  touched: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.bool, PropTypes.array]),
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  options: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.object), PropTypes.arrayOf(PropTypes.string)]),
  disabled: PropTypes.bool,
  inline: PropTypes.bool.isRequired,
  clearable: PropTypes.bool.isRequired,
  components: PropTypes.shape({
    Option: PropTypes.func
  }),
  getOptionLabel: PropTypes.func,
  getOptionValue: PropTypes.func,
  columns: PropTypes.number
};
CordataRadioGroup.defaultProps = {
  error: undefined,
  touched: false,
  className: undefined,
  value: undefined,
  options: undefined,
  disabled: false,
  components: undefined,
  getOptionLabel: undefined,
  getOptionValue: undefined,
  columns: undefined
};
export default CordataRadioGroup;